<template>
  <div class="row mb-3">
    <div class="col-md-12">
      <small class="text-secondary">{{ name }} <span class="text-danger" v-if="isRequired">*</span> </small>
    </div>
    <div class="col-md-12">
      <div class="form-check form-check-inline" v-for="option in options" :key="option[index]">
        <input
            v-model="input"
            @change="check($event)"
            class="form-check-input"
            type="checkbox"
            :id="property + '[' + option['value'] + ']'"
            :value="option['value']"
            :class="{'is-invalid': error }"
            :disabled="disabled"
        >
        <label class="form-check-label text-capitalize" :for="property + '['+ option['value'] +']'">{{ option['text'] }}</label>
      </div>
    </div>
    <div class="col-md-12">
      <message-error :code="errorCode" :hasError="error"/>
    </div>
  </div>

</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'Checkbox',
  components: { MessageError },
  props:{
    value:{},
    property: {type: String},
    name: {type: String},
    options: {type: Array},
    index: {type: String},
    error:{ type: Boolean },
    isRequired:{ type: Boolean },
    disabled:{ default: false, type: Boolean },
    errorCode: { type: String }
  },
  data(){
    return {
      input:[]
    }
  },
  watch:{
    value(val){
      this.input = val
    }
  },
  methods:{
    check(e){
      this.$nextTick(() => {
        if(!this.input.includes(e.target.value) && e.target.checked){
            this.input.push(e.target.value)
        }
        if(!e.target.checked && this.input.includes(e.target.value)){
          const index = this.input.findIndex(x => x === e.target.value)
          this.input.splice(index,1)
        }
      })
      const arr = [...new Set(this.input)]
      this.$emit('input',arr)
    }
  }
}
</script>

<style scoped>

</style>
